'use client';

import '../../../_virtual/_tslib.js';
import { defaultTooltip, defaultFont, LIST_COLORS } from '../../helper/config.js';
import drawing from '../../helper/drawing.js';
import animation from '../../helper/animation.js';

var ALPHA = 0.05;
var VELOCITY = 7;
var OFFSET = 10;
/* Tooltip style */
var TITLE_MARGIN = 12;
var CONTENT_MARGIN = 10;
var CONTENT_GAP = 4;
function Tooltip(props) {
    var tooltipData = props.tooltipData, config = props.config, ctx = props.ctx, mouse = props.mouse; props.canvasSize; var chartArea = props.chartArea, control = props.control;
    function draw() {
        var _a;
        /*
         * Getting config
         * */
        var _b = (((_a = config.default) === null || _a === void 0 ? void 0 : _a.font) || {}).family, fontFamily = _b === void 0 ? defaultFont.family : _b;
        var _c = config.tooltip || {}, title = _c.title, content = _c.content, padding = _c.padding, boxShadow = _c.boxShadow, borderRadius = _c.borderRadius, backgroundColor = _c.backgroundColor;
        var _d = (config.default || {}).listColors, listColors = _d === void 0 ? LIST_COLORS : _d;
        var tooltipPadding = padding || defaultTooltip.padding;
        var tooltipBorderRadius = borderRadius || defaultTooltip.borderRadius;
        var tooltipBackgroundColor = backgroundColor || defaultTooltip.backgroundColor;
        var _e = title || {}, _f = _e.size, titleSize = _f === void 0 ? defaultTooltip.title.size : _f, _g = _e.weight, titleWeight = _g === void 0 ? defaultTooltip.title.weight : _g, _h = _e.color, titleColor = _h === void 0 ? defaultTooltip.title.color : _h, titleDecoration = _e.decoration;
        var _j = content || {}, _k = _j.color, contentColor = _k === void 0 ? defaultTooltip.content.color : _k, _l = _j.weight, contentWeight = _l === void 0 ? defaultTooltip.content.weight : _l, _m = _j.size, contentSize = _m === void 0 ? defaultTooltip.content.size : _m, contentDecoration = _j.decoration;
        var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartEndingPointInXAxis = chartArea.chartEndingPointInXAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis;
        /*
         * Calculating tooltip size
         * */
        var name = tooltipData.name, data = tooltipData.data;
        /* Title */
        ctx.save();
        /*
         * Set default title font for calculating
         * */
        ctx.font = "".concat(titleWeight, " ").concat(titleSize, "px ").concat(fontFamily);
        var displayTitle = titleDecoration ? titleDecoration({ key: name, value: '' }) : name;
        var _o = ctx.measureText(displayTitle), titleBoundingBoxAscent = _o.actualBoundingBoxAscent, titleBoundingBoxDescent = _o.actualBoundingBoxDescent, titleWidth = _o.width;
        ctx.restore();
        var contentWidth = titleWidth;
        var totalHeight = tooltipPadding + titleBoundingBoxAscent + titleBoundingBoxDescent + TITLE_MARGIN;
        var titleHeight = titleBoundingBoxAscent + titleBoundingBoxDescent;
        /*
         * Set default content font for calculating
         * */
        ctx.save();
        ctx.font = "".concat(contentWeight, " ").concat(contentSize, "px ").concat(fontFamily);
        if (typeof data === 'object') {
            Object.keys(data).map(function (key, index) {
                var displayKey = contentDecoration ? contentDecoration({ key: key, value: data[key].toString() }) : key;
                var _a = ctx.measureText("".concat(displayKey).concat(data[key])), textWidth = _a.width, actualBoundingBoxAscent = _a.actualBoundingBoxAscent, actualBoundingBoxDescent = _a.actualBoundingBoxDescent;
                if (contentWidth < textWidth + CONTENT_GAP) {
                    contentWidth = textWidth + CONTENT_GAP;
                }
                if (index !== Object.keys(data).length - 1) {
                    totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + CONTENT_MARGIN;
                }
                else {
                    totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + tooltipPadding;
                }
            });
        }
        else {
            var decorationValue = contentDecoration
                ? contentDecoration({ key: '', value: String(data) })
                : String(data);
            var _p = ctx.measureText(decorationValue), actualBoundingBoxAscent = _p.actualBoundingBoxAscent, actualBoundingBoxDescent = _p.actualBoundingBoxDescent, textWidth = _p.width;
            if (contentWidth < textWidth) {
                contentWidth = textWidth;
            }
            totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + tooltipPadding;
        }
        ctx.restore();
        var rectWidth = contentWidth + tooltipPadding * 2;
        var rectHeight = totalHeight;
        if (mouse) {
            /*
             * Collision detection
             * */
            if (mouse.x >= chartStartingPointInXAxis &&
                mouse.x <= chartEndingPointInXAxis &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                control.dx = mouse.x + OFFSET - control.xPos;
                control.dy = mouse.y - totalHeight - control.yPos;
                control.xPos += control.dx / VELOCITY;
                control.yPos += control.dy / VELOCITY;
                control.opacity += ALPHA;
                if (control.opacity >= 1) {
                    control.opacity = 1;
                }
            }
            else {
                control.opacity -= ALPHA * 2;
                if (control.opacity <= 0) {
                    control.opacity = 0;
                }
            }
        }
        else {
            control.opacity -= ALPHA * 2;
            if (control.opacity <= 0) {
                control.opacity = 0;
            }
        }
        var tooltipReachTheEndOfChartArea = control.xPos + contentWidth + tooltipPadding * 2;
        if (tooltipReachTheEndOfChartArea >= chartEndingPointInXAxis) {
            control.xPos = chartEndingPointInXAxis - (contentWidth + tooltipPadding * 2);
        }
        if (control.yPos <= chartEndingPointInYAxis) {
            control.yPos = chartEndingPointInYAxis;
        }
        ctx.beginPath();
        ctx.save();
        ctx.globalAlpha = animation.easeInOutSine(control.opacity);
        ctx.fillStyle = tooltipBackgroundColor;
        /*
         * Box shadow
         * */
        ctx.shadowOffsetX = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.offsetX) || defaultTooltip.boxShadow.offsetX;
        ctx.shadowOffsetY = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.offsetY) || defaultTooltip.boxShadow.offsetY;
        ctx.shadowBlur = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.blur) || defaultTooltip.boxShadow.blur;
        ctx.shadowColor = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.color) || defaultTooltip.boxShadow.color;
        /*
         * End box shadow
         * */
        /*
         * Drawing card
         * */
        drawing.roundRect(ctx, control.xPos, control.yPos, rectWidth, rectHeight, tooltipBorderRadius);
        ctx.fill();
        ctx.fillStyle = '#333';
        /*
         * Title
         * */
        var xStartingPosition = control.xPos + tooltipPadding;
        ctx.save();
        /*
         * Setting default font style for title
         * */
        ctx.font = "".concat(titleWeight, " ").concat(titleSize, "px ").concat(fontFamily);
        ctx.fillStyle = titleColor || '';
        /*
         * Fill title
         * */
        ctx.fillText(displayTitle, xStartingPosition, control.yPos + titleHeight + tooltipPadding);
        ctx.restore();
        /*
         * Content
         * */
        ctx.save();
        ctx.font = "".concat(contentWeight, " ").concat(contentSize, "px ").concat(fontFamily);
        ctx.fillStyle = contentColor || '';
        ctx.save();
        var contentStartPosition = control.yPos + titleHeight + tooltipPadding + TITLE_MARGIN;
        if (typeof data === 'object') {
            Object.keys(data).forEach(function (key, index) {
                var startPosition = xStartingPosition;
                var decorationValue = contentDecoration
                    ? contentDecoration({ key: key, value: data[key].toString() })
                    : key;
                var _a = ctx.measureText(data[key].toString()), width = _a.width, actualBoundingBoxAscent = _a.actualBoundingBoxAscent, actualBoundingBoxDescent = _a.actualBoundingBoxDescent;
                contentStartPosition += actualBoundingBoxAscent + actualBoundingBoxDescent;
                if (!(content === null || content === void 0 ? void 0 : content.decoration)) {
                    ctx.save();
                    ctx.fillStyle = listColors[index].foreground;
                    ctx.fillText(data[key].toString(), startPosition, contentStartPosition);
                    ctx.restore();
                    startPosition += width + CONTENT_GAP;
                }
                ctx.fillText(decorationValue, startPosition, contentStartPosition);
                contentStartPosition += CONTENT_MARGIN;
            });
        }
        else {
            var decorationValue = contentDecoration
                ? contentDecoration({ key: '', value: String(data) })
                : String(data);
            var _q = ctx.measureText(decorationValue), actualBoundingBoxAscent = _q.actualBoundingBoxAscent, actualBoundingBoxDescent = _q.actualBoundingBoxDescent;
            contentStartPosition += actualBoundingBoxAscent + actualBoundingBoxDescent;
            ctx.fillText(decorationValue, xStartingPosition, contentStartPosition);
        }
        ctx.restore();
        ctx.restore();
        ctx.restore();
        ctx.closePath();
    }
    return { draw: draw };
}

export { Tooltip as default };
//# sourceMappingURL=tooltip.js.map
